import ControlBar from "./ControlBar";
import ImgSlider from "../../../../shared/ImgSlider/ImgSlider";

import styles from "./styles.module.scss";

const ProductItemInfoSection = () => {
  return (
    <div className={styles.productItemInfoSection}>
      <div className={styles.sliderWrapper}>
        <ImgSlider />
      </div>
      <div className={styles.controlBarWrapper}>
        <ControlBar />
      </div>
    </div>
  );
};

export default ProductItemInfoSection;
